import { UserOutlined, EditOutlined, ClockCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const ActivityHistoryWrapper = styled.div`
  background: #fbfbfb;
`;

export const ActivityItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 10px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s;
  border-radius: 3px;
  ul{
    padding-inline-start: 0 !important;
  }
`;

export const ActivityIcon = styled.div`
  margin-right: 15px;
  font-size: 24px;
  color: #1890ff;
`;

export const ActivityDetails = styled.div`
  flex-grow: 1;
  .activity-meta {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .meta-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    span {
      margin-left: 5px;
      color: #555;
    }
  }
  p {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 2fr; /* Tỷ lệ cố định cho các cột */
  margin-top: -15px;
  border-collapse: collapse;
  table-layout: fixed; /* Đảm bảo kích thước cố định cho bảng */
  width: 100%;
`;

export const TableCell = styled.div`
  padding: 10px;
  overflow-wrap: break-word; /* Ngắt từ nếu quá dài */
  word-break: break-all; /* Ngắt từ dài thành dòng mới */
  white-space: normal; /* Cho phép xuống dòng */
  
  &.title {
    background-color: #0056b3;
    color: #fff;
    font-weight: bold;
  }
`;

// Icon components with styled
export const UserIcon = styled(UserOutlined)`
  font-size: 18px;
  margin-right: 5px;
`;

export const EditIcon = styled(EditOutlined)`
  font-size: 18px;
  margin-right: 5px;
`;

export const ClockIcon = styled(ClockCircleOutlined)`
  font-size: 18px;
  margin-right: 5px;
`;
